module.exports = __webpack_public_path__ + "static/img/success.5a892b49.svg";